import { render } from "./DashboardingName.vue?vue&type=template&id=5866ab2a&lang=pug"
import script from "./DashboardingName.vue?vue&type=script&lang=js"
export * from "./DashboardingName.vue?vue&type=script&lang=js"

import "./DashboardingName.vue?vue&type=style&index=0&id=5866ab2a&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__